import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';

import { FormCheckboxComponent } from './form-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  FormErrorModule,
  MatFormFieldModule,
  MatIconModule,
  MatSlideToggleModule,
  ReactiveFormsModule,
  MatCheckboxModule,
];

@NgModule({
  declarations: [FormCheckboxComponent],
  imports: [...imports, CommonModule],
  exports: [FormCheckboxComponent],
})
export class FormCheckboxModule {}
